/*
 * <nibby-journey>: moves the marker down the timeline as the page scrolls.
 * --p (0–1) = how far the middle of the viewport has travelled through the track.
 * Stages whose dot is above the marker get .is-reached.
 */
if (!customElements.get('nibby-journey')) {
  customElements.define(
    'nibby-journey',
    class NibbyJourney extends HTMLElement {
      connectedCallback() {
        this.stages = Array.from(this.querySelectorAll('[data-journey-stage]'));
        this.ticking = false;
        this.onScroll = () => {
          if (this.ticking) return;
          this.ticking = true;
          requestAnimationFrame(() => {
            this.update();
            this.ticking = false;
          });
        };
        this.observer = new IntersectionObserver((entries) => {
          const visible = entries.some((entry) => entry.isIntersecting);
          if (visible) {
            window.addEventListener('scroll', this.onScroll, { passive: true });
            window.addEventListener('resize', this.onScroll, { passive: true });
            this.update();
          } else {
            window.removeEventListener('scroll', this.onScroll);
            window.removeEventListener('resize', this.onScroll);
          }
        });
        this.observer.observe(this);
        this.update();
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
      }

      update() {
        const rect = this.getBoundingClientRect();
        const anchor = window.innerHeight * 0.55;
        const progress = Math.min(1, Math.max(0, (anchor - rect.top) / Math.max(1, rect.height)));
        this.style.setProperty('--p', progress.toFixed(4));
        const markerY = rect.top + 8 + progress * (rect.height - 16);
        this.stages.forEach((stage) => {
          const dot = stage.querySelector('.nibby-journey__dot') || stage;
          stage.classList.toggle('is-reached', dot.getBoundingClientRect().top <= markerY + 4);
        });
      }
    }
  );
}
